<template>
  <div class="websocket-box">
    <!-- 报警闪烁边框 -->
    <div class="gradient-top" v-show="fireShowFlash"></div>
    <div class="gradient-left" v-show="fireShowFlash"></div>
    <div class="gradient-bottom" v-show="fireShowFlash"></div>
    <div class="gradient-right" v-show="fireShowFlash"></div>
    <!-- 督促弹框 -->
    <transition name="el-zoom-in-bottom">
      <!-- 消息 -->
      <!-- <div style="width: 835px;display:inline-block;"></div> -->
      <!-- 报警推送样式 -->
      <div class="pop-up" v-show="isPopUp">
        <div class="content-wrap no-video">
          <div class="title">
            <div class="alarm-name">
              <img :src="alarmImg" alt="">
              <span>告警通知</span>
            </div>
            <div class="alarm-con">
              <i class="el-icon-close" @click="closeMarguee"></i>
            </div>
          </div>
          <div class="alarm-info">
            <div class="con">告警企业： <span>{{ urgeContent.enterpriseName }}</span></div>
            <div class="con">告警区域： <span>{{ urgeContent.regionName }}</span></div>
            <div class="con">告警地址： <span>{{ urgeContent.instrumentAddress }}</span></div>
            <div class="con">设备名称： <span>{{ urgeContent.detectorModel }}</span></div>
            <div class="con">告警时间： <span>{{ urgeContent.alarmTime | parseTime }}</span></div>
            <div class="con">告警等级： <span>{{ urgeContent.alarmLevelName }}</span></div>
            <div class="con">告警描述： <span>{{ urgeContent.description }}</span></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  baseWebSocketPath
} from '@/config/env'
import {
  getToken
} from '@/api/login'
const alarmImg = require('@/assets/images/tongzhi.png')
export default {
  data() {
    return {
      alarmImg,
      fireShowFlash: false,
      isPopUp: false,
      urgeContent: {},
      timeout: null
    }
  },
  computed: {
    userId() {
      return this.$store.getters.userId
    },
    projectId() {
      return this.$store.getters.projectId
    },
    alarmData() {
      return this.$store.getters.alarmData
    }
  },
  watch: {
    // 消息通知 推送
    alarmData(n, o) {
      if (n) {
        // console.log('n', n)
        // 1预警 2报警
        let code = n.code
        if (code === 1 || code === 2) {
          // 如果isNewly=0，则表示新增隐患，则需要前端弹窗，其他则刷新左侧
          this.urgeContent = n.data
          this.isPopUp = true
          this.fireShowFlash = true
          // clearTimeout(this.timeout)
          // this.timeout = setTimeout(() => {
          //   this.isPopUp = false
          //   this.fireShowFlash = false
          // }, 10000)
        } else {
          this.isPopUp = false
          this.fireShowFlash = false
        }
      }
    },
    userId(n, o) {
      if (n) {
        this.initsocket()
      }
    }
  },
  mounted() {
    // setTimeout(() => {
    // this.$store.dispatch('setAlarmData', { code: 1, data: {} })
    // this.$store.dispatch('setReceivedMsg', 12)
    // console.log('setReceivedMsg', this.$store.getters.receivedMsg)
    // }, 3000)
  },
  created() {
    console.log('websocket=', this.userId)
    if (this.userId) {
      this.initsocket()
    }
    // this.isPopUp = true
    // this.tokens = this.randomString(30)
    // this.getToken()
  },
  methods: {
    closeMarguee() {
      this.fireShowFlash = false
      this.isPopUp = false
    },
    getToken() {
      getToken()
        .then(res => {
          if (res.code === '000000') {
            this.tokens = res.data
            this.initsocket()
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    goFire() {
      let stationId = this.$store.getters.stationId
      this.$router.push({ name: 'areaMonitor', params: { 'stationId': stationId } })
    },
    // 获取随机字符串
    randomString(len) {
      len = len || 32
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    Query(code, data) {
      this.code = code
      this.data = data
    },
    // websocket
    initsocket() {
      var lockReconnect = false // 避免重复连接
      if ('WebSocket' in window) {
        // console.log('您的设备支持webSocket')
        // 打开一个 web socket
        var ws
        let _this = this
        // _this.getCookie()
        // console.log(_this.projectId)

        if (window.location.protocol === 'http:') {
          ws = new WebSocket('ws://' + baseWebSocketPath + '/electrical-device-message-process/endpoint/' + _this.userId)
        } else {
          ws = new WebSocket('wss://' + baseWebSocketPath + '/electrical-device-message-process/endpoint/' + _this.userId)
        }
        ws.onopen = function () {
          ws.send('100')
          setInterval(function () {
            ws.send('100')
          }, 30000)
        }
        ws.onmessage = function (evt) {
          let receivedMsg = evt.data
          // console.log('推送,', evt, receivedMsg)
          let webso = receivedMsg === 'deviceReset' ? receivedMsg : JSON.parse(receivedMsg)
          let msgCode = receivedMsg === 'deviceReset' ? receivedMsg : JSON.parse(receivedMsg).code
          // console.log(webso)
          // 2报警 1预警
          if (msgCode === 1 || msgCode === 2) { // 告警
            _this.$store.dispatch('setAlarmData', webso)
          }
        }
        ws.onclose = function () {
          if (lockReconnect) return
          lockReconnect = true
          setTimeout(function () {
            lockReconnect = false
            _this.initsocket()
          }, 10000)
        }
        ws.onerror = function () {
          if (lockReconnect) return
          lockReconnect = true
          setTimeout(function () {
            lockReconnect = false
            _this.initsocket()
          }, 10000)
        }
      } else {
        // 浏览器不支持 WebSocket
        alert('您的浏览器不支持 WebSocket!,请升级最新的浏览器使用')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gradient-top {
  position: absolute;
  top: 0px;
  z-index: 1200;
  width: 100%;
  height: 25px;
  background: linear-gradient(180deg, #ff17007a 10%, transparent 90%);
  animation: gradient 1s infinite;
}

.gradient-left {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1200;
  width: 35px;
  height: 100%;
  background: linear-gradient(90deg, #ff17007a -30%, transparent 90%);
  /* 标准的语法（必须放在最后） */
  animation: gradient 1s infinite;
}

.gradient-bottom {
  position: absolute;
  bottom: 0px;
  z-index: 1200;
  width: 100%;
  height: 25px;
  background: linear-gradient(0deg, #ff17007a -30%, transparent 90%);
  animation: gradient 1s infinite;
}

.gradient-right {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1200;
  width: 35px;
  height: 100%;
  background: linear-gradient(-90deg, #ff17007a -30%, transparent 90%);
  animation: gradient 1s infinite;
}

@keyframes gradient {

  /*设置内容由显示变为隐藏*/
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.pop-up {
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 10000;

  .content-wrap {
    width: 300px;
    background-color: #fff;
    border-radius: 6px 6px 0px 0px;
    color: #333;

    .title {
      display: flex;
      // background: rgba(252, 94, 3, 1);
      background-color: #fb5210;
      border-radius: 6px 6px 0px 0px;
      width: 100%;
      height: 30px;
      font-size: 14px;
      position: relative;

      .alarm-name {
        flex: 1;
        color: #ffffff;
        line-height: 30px;
        letter-spacing: 0px;
        padding-left: 20px;

        img {
          width: 16px;
        }
      }

      .alarm-con {
        position: absolute;
        top: 0px;
        right: 10px;
        line-height: 30px;
        text-align: right;
        color: #ffffff;
        text-align: right;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .alarm-info {
      // height: calc(100% - 30px);
      padding: 15px 20px 7px;
      font-size: 14px;
      color: #999;
      box-shadow: inset 0px 0px 30px 4px rgba(252, 94, 3, 0.4);

      .con {
        margin-bottom: 7px;

        span {
          color: #333;
        }
      }

      .video-check {
        cursor: pointer;
      }
    }
  }

  .content-wrap.no-video {
    // height: 130px;
  }
}
</style>
